'use client';

import { useEffect } from 'react';
import { runWhenIdle } from '@/lib/browserSurface';

export function AnalyticsInitializer() {
  useEffect(() => {
    let cancelled = false;

    const run = () => {
      if (cancelled) return;
      void import('@/bootstrap/analytics')
        .then((mod) => {
          if (cancelled) return;
          mod.initAnalytics();
        })
        .catch((err) => {
          console.error('[AnalyticsInitializer] failed to load analytics:', err);
        });
    };

    const cancel = runWhenIdle(run);
    return () => {
      cancelled = true;
      cancel();
    };
  }, []);

  return null;
}
